package music.jammers.shared.event.domain.model

import kotlinx.serialization.Serializable
import music.jammers.shared.event.track.domain.model.EventTrack

@Serializable
data class EventFreezeData(
    val freeze: Boolean,
    val tracks: List<EventTrack>,
    val backlog: List<EventTrack>,
)